import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { DepositLimitUpdatePopupState } from 'src/domains/players/state/accountState/DepositLimitsUpdatePopups/DepositLimitUpdatePopup/DepositLimitUpdatePopup.state';
import {
    DepositLimitUpdateContainer,
    DepositLimitUpdateOverlay,
    PopupTitle,
    PopupParagraph,
    SubmitButton,
} from 'src/domains/players/state/accountState/DepositLimitsUpdatePopups/DepositLimitUpdatePopup/DepositLimitUpdatePopup.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';

interface PopupWrapperProps {
    state: DepositLimitUpdatePopupState;
    version?: 'tertiary';
    buttonVariant: 'submit' | 'accept';
    children: React.ReactNode;
}

export const PopupWrapper = observer(
    'PopupWrapper',
    ({ state, version, buttonVariant, children }: PopupWrapperProps): JSX.Element => {
        const firstName = state.userBasicData?.firstName ?? '';

        return (
            <DepositLimitUpdateOverlay>
                <DepositLimitUpdateContainer version={version}>
                    <PopupTitle>
                        <I18n
                            langKey='deposit-limit-update.popup.title'
                            defaultText='Deposit Limit Update'
                        />
                    </PopupTitle>
                    <PopupParagraph>
                        <I18n
                            langKey='deposit-limit-update.popup.greeting'
                            defaultText='Hi {firstName},'
                            params={{ firstName }}
                        />
                    </PopupParagraph>

                    {children}

                    <SubmitButton
                        size='large'
                        onClick={state.onSubmitRequest}
                        isLoading={state.isLoading}
                        disabled={state.isLoading}
                    >
                        {buttonVariant === 'accept' ? (
                            <I18n
                                langKey='deposit-limit-update.button.accept'
                                defaultText='Accept'
                            />
                        ) : (
                            <I18n
                                langKey='deposit-limit-update.button.submit'
                                defaultText='Continue'
                            />
                        )}
                    </SubmitButton>
                </DepositLimitUpdateContainer>
            </DepositLimitUpdateOverlay>
        );
    }
);
